import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { devicesApi, type DeviceCreate } from '../api/devices'
import { message } from 'antd'

export function useDeviceList(params?: { status?: string; page?: number; page_size?: number }) {
  return useQuery({
    queryKey: ['devices', params],
    queryFn: () => devicesApi.list(params),
    refetchInterval: 30000,
  })
}

export function useDevice(id: string) {
  return useQuery({
    queryKey: ['device', id],
    queryFn: () => devicesApi.get(id),
    enabled: !!id,
    refetchInterval: 15000,
  })
}

export function useRegisterDevice() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: DeviceCreate) => devicesApi.register(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['devices'] })
    },
    onError: (err: Error) => {
      message.error(err.message)
    },
  })
}

export function useUpdateDevice() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<DeviceCreate> }) =>
      devicesApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['devices'] })
      qc.invalidateQueries({ queryKey: ['device'] })
      qc.invalidateQueries({ queryKey: ['device-schema'] })
      message.success('设备已更新')
    },
    onError: (err: Error) => {
      message.error(err.message)
    },
  })
}

export function useDeleteDevice() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => devicesApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['devices'] })
      message.success('设备已删除')
    },
    onError: (err: Error) => {
      message.error(err.message)
    },
  })
}
